import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import { Button } from 'reactstrap';

import PaymentContext from 'Components/Payment/payment-context';
import CheckoutUtils from 'Helpers/Checkout/CheckoutUtils';

export default function PaymentButton({
  type,
  savedCardId,
  name,
  isDisabled,
  disabledAction,
  paymentMethod,
  enableOneClick,
  adyenComponent,
}) {
  const paymentContext = useContext(PaymentContext);
  const { setError, isSubscription, isNewSavedMethod } = paymentContext;
  const [processingPayment, setProcessingPayment] = useState(false);

  const clickAction = isDisabled ? disabledAction : () => {
    CheckoutUtils.submitPayment(
      paymentContext,
      setError,
      type,
      paymentMethod,
      adyenComponent,
      setProcessingPayment,
      enableOneClick,
      savedCardId,
    );
  };

  return (
    <React.Fragment>
      {(type !== 'paypal') &&
        <Button color="primary" className="order-button complete-button" disabled={processingPayment} onClick={clickAction}>
          {processingPayment &&
            <FontAwesomeIcon spin icon={faSpinner} className="mr-2" />
          }
          {!isSubscription && !isNewSavedMethod && (
            (name === 'Credit Card' || name === 'Card')
              ? <FormattedMessage id="payment-button.card" defaultMessage="Pay with Card Payment" />
              : <FormattedMessage id="payment-button.other" defaultMessage="Pay with {paymentMethod}" values={{ paymentMethod: name }} />
          )}
          {isSubscription && (
            (name === 'Credit Card' || name === 'Card')
              ? <FormattedMessage id="payment-button.card-subscribe" defaultMessage="Subscribe with Card Payment" />
              : <FormattedMessage id="payment-button.other-subscribe" defaultMessage="Subscribe with {paymentMethod}" values={{ paymentMethod: name }} />
          )}
          {isNewSavedMethod && (
            (name === 'Credit Card' || name === 'Card')
              ? <FormattedMessage id="payment-button.card-add" defaultMessage="Save Card" />
              : <FormattedMessage id="payment-button.other-add" defaultMessage="Save {paymentMethod}" values={{ paymentMethod: name }} />
          )}
        </Button>
      }
      {type === 'paypal' &&
        <button className="paypal-btn d-flex justify-content-center align-items-center" disabled={processingPayment} onClick={clickAction}>
          <div>
            <strong className="pr-1">
              <FormattedMessage id="payment-button.paypal-msg" defaultMessage="Pay with" />
            </strong>
          </div>
          <div>
            <img src="https://cdn.fanatical.com/production/product/payment-logos/paypal-colour-simple.svg" alt="paypal" />
          </div>
        </button>
      }
    </React.Fragment>
  );
}

PaymentButton.propTypes = {
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  savedCardId: PropTypes.string,
  isDisabled: PropTypes.bool,
  enableOneClick: PropTypes.bool,
  disabledAction: PropTypes.func,
  paymentMethod: PropTypes.shape({}),
  adyenComponent: PropTypes.shape({}),
};

PaymentButton.defaultProps = {
  savedCardId: '',
  isDisabled: false,
  enableOneClick: false,
  disabledAction: () => {},
  paymentMethod: null,
  adyenComponent: null,
};
